import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {   actionsFormatter,
    dateFormatter, getFieldByPathFormatter, priceFormatter, linkFormatter} from 'util/Utils';
import {calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';

import formatNumbers from 'util/formatNumbers';
import config from '../../../config';
import moment from 'moment';
import {Button} from 'react-bootstrap';
import _ from 'lodash';

var productStatusMap = {
    'Inactive': 'Not On Sale',
    'Active': 'Live',
}

class SellerProductsListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            sellerProducts: this.props.sellerProducts,
        };
        this.currentIntervalReference = false;
        this.touchInProgress = false;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({sellerProducts: nextProps.sellerProducts})
    }

    displayColumn(columnName) {
        switch (columnName) {
            case 'Status':
                return <TableHeaderColumn width="60px" dataFormat={ this.statusFormatter.bind(this) }
                                          dataField='TransactionOrProductStatus' dataAlign="center"
                                          editable={false}
                                          dataSort={true}>Status</TableHeaderColumn>
            case 'Payout':
                return <TableHeaderColumn width="60px" dataAlign="center" editable={false}
                                          dataFormat={ this.payoutFormatter.bind(this) }>Payout</TableHeaderColumn>
            case 'Published':
                return <TableHeaderColumn width="60px" dataAlign="center" editable={false}

                                          dataFormat={ this.publishedFormatter.bind(this) }>Published</TableHeaderColumn>
            case 'DaysToSell':
                return <TableHeaderColumn width="70px" dataAlign="center"
                                          dataFormat={ this.formatDaysLeftToSell.bind(this) }
                                          dataSort={false}>Days To Sell</TableHeaderColumn>
            case 'AvailableQuantity':
                return <TableHeaderColumn width="25px" dataField='ProductVariants.0.Quantity' dataAlign="center"
                                          formatExtraData={ {path: ['ProductVariants', 0, 'Quantity']}}

                                          dataFormat={ getFieldByPathFormatter }>Qty</TableHeaderColumn>
            case 'FundsAvailable':
                return   <TableHeaderColumn width="50px" dataField='FundsAvailableForPaymentAt' dataAlign="center"
                                            dataFormat={ dateFormatter }
                                            editable={false}
                                            formatExtraData={ {'name': 'FundsAvailableForPaymentAt', 'format': 'MM/DD/YY'} }
                                            dataSort={true}>Funds Available</TableHeaderColumn>



        }

    }

    formatDaysLeftToSell(cell, row) {
        var ProductStatus = _.get(row, 'TransactionOrProductStatus', row.Status)
        if (ProductStatus !== 'Active') {
            if (ProductStatus == 'Returned') {

                var ProductIsRestocked = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
                    if (_.includes(['cancel', 'return', 'legacy_restock'], _.get(changeLog, 'CustomData.RestockType'))) {
                        if (_.get(changeLog, 'OrderID') == _.get(row, '$LatestSaleTransaction.SaleData.OrderID')) {
                            return true
                        }
                    }
                })
                if (!ProductIsRestocked) {
                    return 'n/a'
                }

            } else {
                return 'n/a'
            }
        }

        var changeLogFound = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
            if (_.get(changeLog, 'FieldChanged', '') == 'Status' && _.get(changeLog, 'From', '') == 'Inactive' && _.get(changeLog, 'To', '') == 'Active') {
                return true
            }
        })
        if (changeLogFound) {
            var publishedInShopify = moment(_.get(changeLogFound, 'CustomData.PublishedInShopify', false) ? changeLogFound.CustomData.PublishedInShopify : changeLogFound.Date)
            /* PublishedInShopify does not exist in products added before 12.2018 */
        } else {
            var publishedInShopify = moment(row.createdAt).add(5, 'days')
            /* if changeLog not found assume it was pushed Live in 5 days after creation */
        }
        var DaysToSell = 120 - moment().diff(publishedInShopify, 'days')

        return DaysToSell < 0 ? 0 : DaysToSell


    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []

        menuItemsMap.push({
            onClick: function (row) {
                this.props.showProductPreviewModal(row)
            }, label: 'Preview'
        })
        // menuItemsMap.push({
        //     onClick: function (row) {
        //         this.props.showRequestChangesModal(row)
        //     }, label: 'Request Changes'
        // })

        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    prepareMessageToDisplay(status, latestTransactionRecord = false) {
        var messageToDisplay = ''
        console.log('status', status);
        switch (status) {
            case  'On Sale':
                messageToDisplay =
                    <div>{'Your item is available for purchase and cross-posted for increased visibility!'}</div>
                break;
            case  'Not On Sale':
                messageToDisplay =
                    <div> {'Our wingmoms are working hard on generating your listings! Stay tuned for an approval email from ' }
                        <span className="purpleLighter">connect@goodbuygear.com.</span></div>
                break;
            case   'Pending':
                messageToDisplay =
                    <div>{'Your item sold and will be arriving at its new home soon. Once it is delivered, picked up or shipped the status will be updated to SOLD.'}</div>
                break;
            case   'Pending Payout':
                messageToDisplay =
                    <div>{'You have initiated a payout. Once your payout is issued (within 1-3 business days) you will receive an email confirmation.'}</div>
                break;
            case   'Pending Return':
                messageToDisplay =
                    <div>{'Pending Return - The buyer of your item has initiated a return. As soon as we verify the return eligibility this transaction will be either canceled or available for payout. If the return is accepted, and the item is still able to be sold, we will get it relisted ASAP. If it is unable to be relisted we will let you know what the issue is.'}</div>
                break;
            case   'Returned':
                messageToDisplay =
                    <div >
                        <div className="">Bummer, your item was returned</div>
                        <div className="top5 ">If we're able to re-list it, we will do so ASAP.</div>
                        <div className="top5 ">You should have received an email notice detailing the reason for the
                            return but feel free to <a target="_blank" href="https://goodbuygear.com/pages/contact-us">contact
                                us</a> if you have any questions.
                        </div>

                    </div>
                break;
            case  'Sold':
                messageToDisplay =
                    <div >
                        <div className="">Cha-ching!</div>
                        <div className="top5 ">Your item sold and has arrived at its new home.</div>
                        <div className="top5 ">There is a 3 day window from when the buyer receives an item to when your
                            balance is available for payout.
                        </div>
                        <div className="top5 ">This allows us to honor our buyer guarantee, confirming they are
                            satisfied with their purchase.
                        </div>
                    </div>
                break;
            case    'Paid':
                var paymentAccount = '', paymentMethod = _.find(_.concat(config.allPaymentMethodOptions, [{
                    value: 'Donate',
                    label: 'Donate'
                }]), {value: _.get(this.props.userReducer.seller, ['PaymentMethod',], '')})

                if (paymentMethod && paymentMethod.value == 'Donate') {
                    paymentAccount = _.get(this.props.userReducer.seller, ['PaymentData', [paymentMethod.value], 'email'], '')
                }
                if (latestTransactionRecord) {
                    console.log('latestTransactionRecord', latestTransactionRecord);
                    var latestSetPaidChangeLog = _.findLast(_.get(latestTransactionRecord, 'ChangeLog'), changeLog => {
                        return changeLog.FieldChanged == 'Status' && _.get(changeLog, 'To', '') == 'Paid'
                    })
                    console.log('latestSetPaidChangeLog', latestSetPaidChangeLog);
                    if (_.get(latestSetPaidChangeLog, 'CustomData.PayoutMethod') == 'DirectDeposit') {
                        paymentMethod = {
                            label: 'Direct Deposit on ' + moment(latestSetPaidChangeLog.Date).format('YYYY-MM-DD')
                        }

                    }
                    var textMessage = ''
                    const payoutAmount = calculateTransactionPayoutAmount(latestTransactionRecord, this.props.appData.FeatureFlags);
                    if (paymentMethod) {
                        if (paymentMethod.value == 'Donate') {
                            textMessage = 'We donated ' + formatNumbers.formatMoney(payoutAmount) + ' for this item ' + (paymentAccount ? ' to ' + paymentAccount + ' ' : '') + 'on your behalf! Please check your email for a detailed invoice.';
                        } else {
                            textMessage = 'You were paid ' + formatNumbers.formatMoney(payoutAmount) + ' for this item via ' + paymentMethod.label + '. Please check your email for a detailed invoice.';
                        }
                    } else {
                        textMessage = 'You were paid ' + formatNumbers.formatMoney(payoutAmount) + ' for this item. Please check your email for a detailed invoice.';
                    }
                    messageToDisplay = <div>{textMessage}</div>
                }
                break;
        }
        return messageToDisplay;

    }

    publishedFormatter(cell, row) {
        var PublishedInShopifyChangeLog = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
            if (_.get(changeLog, 'FieldChanged', '') == 'Status' && _.get(changeLog, 'From', '') == 'Inactive' && _.get(changeLog, 'To', '') == 'Active' && _.get(changeLog, 'CustomData.PublishedInShopify')) {
                return true
            }
        })
        if (PublishedInShopifyChangeLog) {
            return moment(_.get(PublishedInShopifyChangeLog, 'CustomData.PublishedInShopify'), _.get(PublishedInShopifyChangeLog.Date)).format("MM/DD/YY")
        }
    }

    payoutFormatter(cell, row) {
         if (_.get(row, 'LatestSaleTransaction._id')) {
                 const payoutAmount = calculateTransactionPayoutAmount(row.LatestSaleTransaction, this.props.appData.FeatureFlags);
                 return formatNumbers.formatMoney(payoutAmount);
        } else {
            return formatNumbers.formatMoney(row.PayoutAmount)
        }

    }

    statusFormatter(cell, row, extra) {
        var Status = _.get(row, 'TransactionOrProductStatus', row.Status)
        if (Status == 'Inactive') {
            var PublishedInShopifyChangeLog = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
                if (_.get(changeLog, 'FieldChanged', '') == 'Status' && _.get(changeLog, 'From', '') == 'Inactive' && _.get(changeLog, 'To', '') == 'Active' && _.get(changeLog, 'CustomData.PublishedInShopify')) {
                    return true
                }
            })
            var PublishedBySellerChangeLog = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
                if (_.get(changeLog, 'CustomData.PublishedBySeller')) {
                    return true
                }
            })
            if (!PublishedInShopifyChangeLog) {
                Status = 'In Progress'
            }
        } else if (Status == 'Returned' || Status == 'Restocked') {

            var ProductIsRestocked = _.find(_.get(row, 'ChangeLog', []), (changeLog) => {
                if (_.includes(['cancel', 'return', 'legacy_restock'], _.get(changeLog, 'CustomData.RestockType'))) {
                    if (_.get(changeLog, 'OrderID') == _.get(row, '$LatestSaleTransaction.SaleData.OrderID')) {
                        return true
                    }
                }
            })
            if (ProductIsRestocked) {
                Status = _.get(row, 'Status', '')
            } else {
                Status = 'Returned'
            }

        }

        return <Button bsStyle="link" onClick={() => {
            var messageToDisplay = this.prepareMessageToDisplay(_.get(productStatusMap, [Status], _.startCase(Status)), _.get(row, '$LatestSaleTransaction'))
            this.props.showProductDetailsModal(messageToDisplay)
        }}> {_.get(productStatusMap, [Status], _.startCase(Status))}</Button>
    }

    checkIfColumnEditable(product) {
         var productStatus = _.get(product, 'TransactionOrProductStatus', product.Status);
        if (_.includes(['Active'], productStatus)) {
            return true
        } else {
            if (productStatus == 'Returned') {

                var ProductIsRestocked = _.find(_.get(product, 'ChangeLog', []), (changeLog) => {
                    if (_.includes(['cancel', 'return', 'legacy_restock'], _.get(changeLog, 'CustomData.RestockType'))) {
                        if (_.get(changeLog, 'OrderID') == _.get(product, '$LatestSaleTransaction.SaleData.OrderID')) {
                            return true
                        }
                    }
                })
                if (ProductIsRestocked) {
                    return true
                }

            } else {
                return false;
            }
        }
    }

    onProductDataChange(row, dataToSave) {
        console.log('onProductDataChange', row.updatedPrice  );
        var self = this;
        var itemIndex = _.findIndex(self.state.sellerProducts, function (record) {
            return row._id == record._id;
        });
        if (_.trim(_.get(dataToSave, 'Price', '')) == '' || isNaN(_.get(dataToSave, 'Price', ''))) {
            this.props.displayMessage({
                messageType: 'warning',
                messagePosition: 'bc',
                'messageCode': 'Please, specify a valid price amount'
            });
            return false;
        }

        if (_.get(dataToSave, 'Price') == row.Price) {
            return false;
        }

        if (formatNumbers.unformat(_.get(dataToSave, 'Price')) < 4.99) {
            this.props.displayMessage({
                messageType: 'warning',
                messagePosition: 'bc',
                'messageCode': 'Price can not be lower than $4.99'
            });
            return false;
        }

        var latestChangeLogByAdministrator = _.findLast(_.get(row, 'ChangeLog', []), item => {
            return item.By !== 'user' && item.FieldChanged == 'Price'
        })
        var firstPriceChangeBySeller = _.find(_.get(row, 'ChangeLog', []), item => {
            return item.By == 'user' && item.FieldChanged == 'Price'
        })
        var upperLimitPrice = _.get(latestChangeLogByAdministrator, 'To', _.get(firstPriceChangeBySeller, 'To', row.Price))
        if (formatNumbers.unformat(_.get(dataToSave, 'Price')) > upperLimitPrice) {
            this.props.displayMessage({
                messageType: 'warning',
                messagePosition: 'br',
                'messageCode': 'Sorry, please choose a lower value for the price of your item'
            });
            return false;
        }
        var dataToUpdate = {
            Price: formatNumbers.unformat(_.get(dataToSave, 'Price', '')),
        }
        var time24hoursAgo = moment().subtract(24, 'hours')
        var pricesChangeLogs = _.filter(_.get(row, 'ChangeLog', []), item => {
            return item.FieldChanged == 'Price'
        })
        /* check if any price set earlier than 24 hours ago is greater than new price */
        var foundChangeLogMade24HoursAgo = _.find(pricesChangeLogs, item => {
            return moment(item.Date).isBefore(time24hoursAgo, 'hour') && formatNumbers.unformat(item.To) > _.get(dataToSave, 'Price')
        })

        if (_.get(dataToSave, 'Price') < row.Price && ( foundChangeLogMade24HoursAgo || _.size(pricesChangeLogs) == 0)) { /* if price is lower than any price set more than 24 hourse ago or there are not change logs for prices */

            dataToUpdate.ProductTagsToAdd = ['SellerReduced']
        }
        self.setState({
            sellerProducts: [...self.state.sellerProducts.slice(0, itemIndex),
                {...self.state.sellerProducts[itemIndex], pending: true},
                ...self.state.sellerProducts.slice(itemIndex + 1)]
        });
        self.props.makeRequest(dataToUpdate, {
            messageData: {'#1#': 'Product'},
            'not_display_success_message': true,
            "endpoint": "/products/" + encodeURIComponent(row._id),
            type: "patch",
        }).then(response => {
            console.log('before search'  );
            self.props.search({displayCurrentPage: true}).then(data=> {
                 self.setState({
                    sellerProducts: [...self.state.sellerProducts.slice(0, itemIndex),
                        {...self.state.sellerProducts[itemIndex], pending: false},
                        ...self.state.sellerProducts.slice(itemIndex + 1)]
                });
            });
        }).catch(err => {
            self.setState({
                sellerProducts: [...self.state.sellerProducts.slice(0, itemIndex),
                    {...self.state.sellerProducts[itemIndex], ['pending']: false},
                    ...self.state.sellerProducts.slice(itemIndex + 1)]
            });
        });
    }

    productNameFormatter(cell, row, extra) {
        if (row.Status == 'Active') {
            if (_.get(row, extra.path, false)) {
                return linkFormatter(cell, row, extra)
            } else {
                return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>
            }

        } else {

            return <a href="#" onClick={() => {
                this.props.showProductPreviewModal(row)
            }}>{_.get(row, 'ProductName')} </a>
        }
    }

    editablePriceFormatter(cell, row) {
        if (!this.checkIfColumnEditable(row)) {
            return priceFormatter(cell, row, {path:'Price'});
        }

        const editedPrice =  _.isUndefined(row.updatedPrice) ? row.Price : row.updatedPrice;
         return <span>
            {row.pending &&  <div className="pending-box"></div>  }
            <input
             className={'form-control cell-edit-input'}
             style={{}}
             onClick={(e) => {
                 e.stopPropagation();
             }}
             type='text'
             value={editedPrice}
             onChange={({target: {value}}) => {
                  const itemIndex = this.state.sellerProducts.findIndex(record => row._id == record._id);
                 this.setState({
                     sellerProducts: [...this.state.sellerProducts.slice(0, itemIndex),
                         {
                             ...this.state.sellerProducts[itemIndex],
                             updatedPrice: value
                         },
                         ...this.state.sellerProducts.slice(itemIndex + 1)]
                 });
             }}/>
            {editedPrice != row.Price &&
             <button
              className='btn btn-primary cell-edit-button'
              disabled={row.pending}
              onClick={() => {
                  this.onProductDataChange(row, {Price: row.updatedPrice});
              }}>
                 Save
             </button>
            }
        </span>;
    }




    render() {
        var self = this;
        console.log('this.props.searchType', this.props.searchType  );
        return (
            <div className=" databases-table">

                <BootstrapTable data={this.state.sellerProducts} ref='table'
                                remote={ true }
                                hover={true}
                                striped={true}

                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange,
                                    //  onRowClick:this.onRowClick.bind(this)
                                } }

                >
                    <TableHeaderColumn width="100px" dataField='ProductName'
                                       editable={false}
                                       dataFormat={ this.productNameFormatter.bind(this) }
                                       formatExtraData={ {
                                           labelPath: ['ProductName'],
                                           path: ['ShopifyProductHandle'],
                                           placeholder: '[product_handle]',
                                           template: config.getEnvironment().shopify.productCustomerUrlTemplate
                                       }  }
                                       dataSort={true}>Product Name</TableHeaderColumn>
                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="90px" formatExtraData={ {path: ['Price']}  }
                                       dataFormat={(cell, row) => {
                                           return self.editablePriceFormatter(cell, row);
                                       } }
                                       columnClassName={(cell, row) => {
                                           return this.checkIfColumnEditable(row) ? 'editable-table-cell' : ''
                                       }}
                                       dataField='Price' dataAlign="center" dataSort={true}> Price</TableHeaderColumn>
                    {this.props.searchType == 'OnSale' ? this.displayColumn('Published') : null}
                    {this.props.searchType == 'OnSale' ? this.displayColumn('DaysToSell') : null}
                    {this.props.searchType == 'OnSale' ? this.displayColumn('AvailableQuantity') : null}
                    {_.includes(['Pending', 'Sold', 'Complete'], this.props.searchType) ? this.displayColumn('Payout') : null}
                    {_.includes(['Pending', 'Complete'], this.props.searchType) ? this.displayColumn('Status') : null}
                    {this.props.searchType == 'Sold' ? this.displayColumn('FundsAvailable') : null}

                </BootstrapTable>

            </div>
        );
    }
}


export default SellerProductsListTable;
